<template>
  <v-dialog v-model="mostrado" max-width="500px" persistent>
    <v-card>
      <v-card-title>{{ titulo }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        {{ mensaje }}
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="aceptar"> ACEPTAR </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmacionMensaje',
  props: {
    titulo: {
      type: String,
      default: '',
    },
    mensaje: {
      type: String,
      default: '',
    },
    mostrado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    aceptar() {
      this.$emit('aceptar');
    },
  },
};
</script>

<style>
</style>